module.exports = __webpack_public_path__ + "img/icon_1_16.8a6ecec3.png";